module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [_c('div', {
    staticClass: "templateDesigner group p-20"
  }, [_c('div', {
    staticClass: "design-options p-10 p-b-0 primarybg",
    class: {
      'm-b-20': (_vm.$store.state.mode === 'designer')
    }
  }, [(_vm.$store.state.mode === 'designer' && _vm.$store.state.templateList !== null) ? _c('a', {
    staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-angle-left m-r-5 primarytext"
  }), _vm._v(" Back to Templates")]) : (_vm.$store.state.mode === 'designer' && _vm.$store.state.template !== null && _vm.$store.state.template.vendors && _vm.$store.state.template.vendors.data.length > 0) ? _c('a', {
    staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg left",
    on: {
      "click": function($event) {
        _vm.$router.push('/templates/vendor')
      }
    }
  }, [_c('span', {
    staticClass: "icon-angle-left m-r-5 primarytext"
  }), _vm._v(" Back to Templates")]) : _vm._e(), _vm._v(" "), _vm._l((this.buttons), function(button, index) {
    return _c('button', {
      key: index,
      staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder left",
      class: _vm.checkActive(button),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.switchTemplate(button)
        }
      }
    }, [_vm._v(_vm._s(button))])
  }), _vm._v(" "), (this.$store.state.mode === 'editor') ? _c('button', {
    staticClass: "btn btn-outline-success m-b-10 right primaryborder m-r-5",
    class: {
      'animated pulse orange solid': (_vm.templateChanges())
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveTemplate()
      }
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.templateChanges()) ? _vm.saveStatus : 'Saved ') + "\n                    "), (_vm.templateChanges()) ? _c('span', {
    staticClass: "icon-save m-l-5"
  }) : _c('span', {
    staticClass: "icon-checkmark-circle m-l-5"
  })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.mode === 'designer') ? _c('div', {
    staticClass: "btn-group m-b-10 right"
  }, [_c('button', {
    staticClass: "btn btn-outline-success primaryborder dropdown-toggle waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v("Zoom: " + _vm._s(_vm.zoom * 100 + '%') + " "), _c('span', {
    staticClass: "icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(1)
      }
    }
  }, [_vm._v("100%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.9)
      }
    }
  }, [_vm._v("90%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.8)
      }
    }
  }, [_vm._v("80%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.7)
      }
    }
  }, [_vm._v("70%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.6)
      }
    }
  }, [_vm._v("60%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.5)
      }
    }
  }, [_vm._v("50%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.4)
      }
    }
  }, [_vm._v("40%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.3)
      }
    }
  }, [_vm._v("30%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.2)
      }
    }
  }, [_vm._v("20%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.1)
      }
    }
  }, [_vm._v("10%")])])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.mode === 'designer' && _vm.$store.state.config.hideDeepLinks !== true) ? _c('span', {
    staticClass: "btn btn-outline-primary waves-effect waves-light right m-r-5",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyUrl($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-link"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "canvasEditors"
  }, [(_vm.$store.state.template) ? _c('PrimoCanvas', {
    ref: "primoCanvas",
    attrs: {
      "prod-height": (_vm.$store.state.template) ? _vm.$store.state.template.height : 0,
      "prod-width": (_vm.$store.state.template) ? _vm.$store.state.template.width : 0,
      "prod-safe": (_vm.$store.state.template.safe),
      "prod-bleed": (_vm.$store.state.template.bleed),
      "display-type": this.$store.state.mode
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e539686","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TemplateDesigner.vue
// module id = 324
// module chunks = 0